// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"c0e91183","443":"2369371d","610":"49748b88","694":"7ad7078f","979":"83068b23"}[chunkId] + ".chunk.js";
};